/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Answer_3Inputs */

const en_help_center__bidding_n_battles__answer_3 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each battle has a maximum number of participants (seats). For example, a battle might have 100 or 200 seats. Once all seats are filled, no one else can join. This creates fair competition—you know exactly how many people you're competing against, unlike traditional auctions where unlimited people can join.`)
};

/**
* | output |
* | --- |
* | "Each battle has a maximum number of participants (seats). For example, a battle might have 100 or 200 seats. Once all seats are filled, no one else can join...." |
*
* @param {Help_Center__Bidding_N_Battles__Answer_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__answer_3 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Answer_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Answer_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__answer_3(inputs)
});